
import LayoutContent from '../../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import SpecialsScreen from './../specials';


function Index({dishs, setShowListProduct, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

     const [showSpecials, setShowSpecials] = useState(false);

    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setShowListProduct} setShowSpecials={setShowSpecials} goHome={goHome}>
                <div style={{ padding: '0 20px' }}>
                     <img
                        src={require('../assets/top.png')}
                        style={{
                        objectFit: 'contain',
                        width: '100%',
                        height: 140,
                        marginTop: -10,
                        }}
                    />
                     <p style={{color: 'white', marginTop: 200, textAlign: 'center', fontSize: 35, textTransform: 'uppercase'}}>
                           PISCO (2 0z)
                    </p>

                    <div>
                        <img
                            src={require('./assets/text.png')}
                            style={{
                                width: '100%',
                                height: 150,
                                objectFit: 'contain',
                                borderRadius: 20,
                                marginTop: 20,
                            }}
                        />
                    </div>
                
                </div>
                
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials}  setShowHappy={goHome}/>}

            </LayoutContent>
        </div>
    );
}
export default Index;